import React from "react";
import { RegistrationInputButton } from "@/components/valuation/RegistrationInputButton";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

interface CallToActionSectionProps {
  onValuationClick: () => void;
}

const CallToActionSection = ({
  onValuationClick,
}: CallToActionSectionProps) => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.sellCar?.callToActionSection || {};

  return (
    <div className="h-full">
      <div className="bg-gradient-to-b from-violet-600 to-pink-700 rounded-xl p-4 md:p-5 h-full flex flex-col justify-center">
        <h3 className="text-lg text-center md:text-xl text-white font-bold mb-2">
          {sectionData.title || "Värdera Din Bil"}
        </h3>
        <p className="text-sm text-center text-white mb-3 opacity-90">
          {sectionData.description || "Få en snabb och gratis värdering"}
        </p>

        <RegistrationInputButton onClick={onValuationClick} />
      </div>
    </div>
  );
};

export default CallToActionSection;
